exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".spinner {\n  all: initial;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n  padding: 4rem 0 4rem 0;\n}\n.spinner circle {\n  fill: #005BA5;\n}", ""]);

// exports
